@if (isActive) {
  <topo-modal
    [isActive]="isActive"
    [backgroundCanClose]="true"
    [isCard]="true"
    [width]="980">
    <div class="modal-header">
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center">
        <h5 class="mx-4 my-4">
          {{ 'FILTERS.MODIFY-FILTER' | translate }}
        </h5>
        <div
          class="dialog-close"
          (click)="cancelClick()">
          <i class="icon icon-close-X"></i>
        </div>
      </div>
    </div>
    <div
      class="modal-body"
      style="width: 100%">
      <topo-link-filter-group
        [lookupTargetSchemaFields]="lookupTargetSchemaFields"
        [level]="0"
        [datasets]="datasets"
        [filterGroup]="filterGroup"
      style="width: 100%"></topo-link-filter-group>
      <div style="padding: 50px">&nbsp;</div>
    </div>
    <div class="modal-footer">
      <div
        fxLayout="row"
        fxLayoutAlign="end"
        class="mt-4 mb-4">
        <div style="margin-right: 5px">
          <button
            class="button is-secondary"
            (click)="cancelClick()">
            {{ 'FILTERS.CANCEL' | translate }}
          </button>
        </div>
        <div>
          <button
            class="button is-primary"
            (click)="saveClick()">
            {{ 'FILTERS.SAVE' | translate }}
          </button>
        </div>
      </div>
    </div>
  </topo-modal>
}
